
import React, { useEffect, useState } from "react";
import ApiClient from "../../utils/ApiClient";

export default function POData({ poSelected }) {
    const [poData, setPoData] = useState([]); // State to hold fetched data

    useEffect(() => {
        console.log("getpodata -PODATA");
        console.log(poSelected)
        if (poSelected) {
            ApiClient.post("/api/receiveinventory/getpodata", {
                poNumber: poSelected,
            })
                .then((response) => {
                    console.log("PO Data:", response.data);
                    setPoData(response.data); // Set fetched data to state
                })
                .catch((error) => {
                    console.error("Failed to fetch PO data", error);
                });
        }
    }, [poSelected]); // Dependency ensures the effect re-runs when poSelected changes

    return (
        <div className="px-4 sm:px-6 lg:px-8">
            <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto">
                    <h1 className="text-base font-semibold text-gray-900">Purchase Orders</h1>
                    <p className="mt-2 text-sm text-gray-700">
                        A list of all the products in the selected PO, including their details such as GTIN, SKU, and quantities.
                    </p>
                </div>
                <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                    <button
                        type="button"
                        className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                        Add Item
                    </button>
                </div>
            </div>
            <div className="mt-8 flow-root">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead>
                            <tr>
                                <th scope="col"
                                    className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-3 w-1">
                                    PO <br/> Number
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1">
                                    GTIN
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1">
                                    Supplier SKU
                                </th>
                                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                                    Product Name
                                </th>
                                <th
                                    scope="col"
                                    className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1 whitespace-normal break-words"
                                >
                                    Qty <br/> Ordered
                                </th>
                                <th scope="col"
                                    className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1 whitespace-normal break-words"
                                >
                                    Total <br/> Received
                                </th>
                                <th scope="col"
                                    className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900 w-1 whitespace-normal break-words">
                                    Remaining <br/> Qty
                                </th>
                            </tr>
                            </thead>
                            <tbody className="bg-white">
                            {poData.length > 0 ? (
                                poData.map((item, index) => (
                                    <tr key={index} className={index % 2 === 0 ? "even:bg-gray-50" : "bg-white"}>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
                                            {item.poNumber}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.gtin}</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.supplier_sku}</td>
                                        <td
                                            className="whitespace-normal break-words px-3 py-4 text-sm text-gray-500 max-w-xs"
                                            style={{wordWrap: "break-word", maxWidth: "200px"}}
                                        >
                                            {item.product_name}
                                        </td>
                                        <td className="px-3 py-4 text-center text-sm text-gray-500 whitespace-normal break-words w-1">
                                            {item.qty_ordered}
                                        </td>
                                        <td className="px-3 py-4 text-center text-sm text-gray-500 whitespace-normal break-words w-1">
                                            0
                                        </td>
                                        <td className="px-3 py-4 text-center text-sm text-gray-500 whitespace-normal break-words w-1">
                                            0
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={6}
                                        className="px-3 py-4 text-sm text-gray-500 text-center"
                                    >
                                        No data available for the selected PO.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
